// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

import {notifyBugsnag} from "../errors/bugsnag/notify_bugsnag";
import {SmartAdSASTypes} from "../offer/helpers/smart_add_sas_types";
import {RpStore} from "../store/store";
import {addSmartAdOfferAction, updateSmartAdOfferAction} from "./actions/add_smart_offer_action";
import {AdCreationError} from "./api/creation_error_class";
import {fetchHeroAd} from "./api/fetch_hero_ad";
import {fetchNativeAd} from "./api/fetch_native_ad";
import {fetchSurpriseAd} from "./api/fetch_surprise_ad";
import {fetchTdaAd} from "./api/fetch_tda_ad";
import {getOfferDetails} from "./api/get_offer_details";
import {IAdMeta} from "./types/IAdMeta";

export const createInitAgencyScript =
    (store: RpStore | null) =>
    async (creationId: number, adMeta: IAdMeta): Promise<void> => {
        const {tagId, formatId} = adMeta;

        if (!tagId) {
            const tagError = `tagId is not defined for creation ${creationId}`;
            notifyBugsnag({message: tagError}, tagError);
            console.warn(tagError);
            return;
        }

        const adPlacement = document.getElementById(tagId);
        if (adPlacement === null) {
            const placementError = `placement ${tagId} not found`;
            notifyBugsnag({message: placementError}, placementError);
            console.warn(placementError);
            return;
        }

        if (!store) {
            // TODO: store should be defined, investigate possible null case
            return;
        }

        try {
            switch (parseInt(formatId)) {
                case SmartAdSASTypes.HERO:
                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: null,
                            offerDetails: null,
                            didLoadCreationDetails: false
                        })
                    );

                    const heroCreation = await fetchHeroAd(creationId);

                    store.dispatch(
                        updateSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: heroCreation,
                            offerDetails: null,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
                case SmartAdSASTypes.TDA:
                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: null,
                            offerDetails: null,
                            didLoadCreationDetails: false
                        })
                    );

                    const tdaCreation = await fetchTdaAd(creationId);

                    store.dispatch(
                        updateSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: tdaCreation,
                            offerDetails: null,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
                case SmartAdSASTypes.SURPRISE:
                    const surpriseCreation = await fetchSurpriseAd(creationId);

                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: surpriseCreation,
                            offerDetails: null,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
                default:
                    const nativeAd = await fetchNativeAd(creationId);
                    const offer = nativeAd.offer ? await getOfferDetails(nativeAd.offer.id) : null;

                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: nativeAd,
                            offerDetails: offer,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
            }
        } catch (error: unknown) {
            if (error instanceof AdCreationError) {
                notifyBugsnag({name: "Creation not found"}, error.message, {originalError: error, creationId, adMeta});
                return;
            }
            if (error instanceof Error) {
                notifyBugsnag(error, error.message, {originalError: JSON.stringify(error)});
                return;
            }
            notifyBugsnag({message: "Unknown error while running init_agency_script"}, "init_agency_script error", {originalError: JSON.stringify(error)});
        }
    };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

import {notifyBugsnag} from "../errors/bugsnag/notify_bugsnag";
import {SmartAdSASTypes} from "../offer/helpers/smart_add_sas_types";
import {RpStore} from "../store/store";
import {addSmartAdOfferAction, updateSmartAdOfferAction} from "./actions/add_smart_offer_action";
import {AdCreationError} from "./api/creation_error_class";
import {fetchHeroAd} from "./api/fetch_hero_ad";
import {fetchNativeAd} from "./api/fetch_native_ad";
import {fetchSurpriseAd} from "./api/fetch_surprise_ad";
import {fetchTdaAd} from "./api/fetch_tda_ad";
import {getOfferDetails} from "./api/get_offer_details";
import {IAdMeta} from "./types/IAdMeta";

export const createInitAgencyScript =
    (store: RpStore | null) =>
    async (creationId: number, adMeta: IAdMeta): Promise<void> => {
        const {tagId, formatId} = adMeta;

        if (!tagId) {
            const tagError = `tagId is not defined for creation ${creationId}`;
            notifyBugsnag({message: tagError}, tagError);
            console.warn(tagError);
            return;
        }

        const adPlacement = document.getElementById(tagId);
        if (adPlacement === null) {
            const placementError = `placement ${tagId} not found`;
            notifyBugsnag({message: placementError}, placementError);
            console.warn(placementError);
            return;
        }

        if (!store) {
            // TODO: store should be defined, investigate possible null case
            return;
        }

        try {
            switch (parseInt(formatId)) {
                case SmartAdSASTypes.HERO:
                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: null,
                            offerDetails: null,
                            didLoadCreationDetails: false
                        })
                    );

                    const heroCreation = await fetchHeroAd(creationId);

                    store.dispatch(
                        updateSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: heroCreation,
                            offerDetails: null,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
                case SmartAdSASTypes.TDA:
                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: null,
                            offerDetails: null,
                            didLoadCreationDetails: false
                        })
                    );

                    const tdaCreation = await fetchTdaAd(creationId);

                    store.dispatch(
                        updateSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: tdaCreation,
                            offerDetails: null,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
                case SmartAdSASTypes.SURPRISE:
                    const surpriseCreation = await fetchSurpriseAd(creationId);

                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: surpriseCreation,
                            offerDetails: null,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
                default:
                    const nativeAd = await fetchNativeAd(creationId);
                    const offer = nativeAd.offer ? await getOfferDetails(nativeAd.offer.id) : null;

                    store.dispatch(
                        addSmartAdOfferAction({
                            ...adMeta,
                            creationDetails: nativeAd,
                            offerDetails: offer,
                            didLoadCreationDetails: true
                        })
                    );

                    break;
            }
        } catch (error: unknown) {
            if (error instanceof AdCreationError) {
                notifyBugsnag({name: "Creation not found"}, error.message, {originalError: error, creationId, adMeta});
                return;
            }
            if (error instanceof Error) {
                notifyBugsnag(error, error.message, {originalError: JSON.stringify(error)});
                return;
            }
            notifyBugsnag({message: "Unknown error while running init_agency_script"}, "init_agency_script error", {originalError: JSON.stringify(error)});
        }
    };
